import SchJuly from '../../assets/SchJuly.pdf';
import ResJune from '../../assets/ResJune.pdf';
import Sch_June2026 from '../../assets/Sch_June2026.pdf';
import May2026Res from '../../assets/May2026Res.pdf';
import SchMay from '../../assets/SchMay.pdf';
import ResApril from '../../assets/ResApril.pdf';
import SchApril from '../../assets/SchApril.pdf';
import March2026 from '../../assets/March2026.pdf';
import Mar2026Sch from '../../assets/Sch_March_2026.pdf';
import Result_feb2026 from '../../assets/Feb_2026_Result.pdf';
import Result_Feb from '../../assets/Result_Feb.pdf';
import Jan2026Sch from '../../assets/Jan26Sch.pdf';
import Dec2025Res from '../../assets/Dec2025Res.pdf';
import Dec_Sch from '../../assets/DecSch.pdf';
import Nov_Res from '../../assets/NovResult2025.pdf';
import Nov_Sch from '../../assets/SchNov2025.pdf';
import OctResult25 from '../../assets/OctResult25.pdf';
import October_Sch from '../../assets/October_sch.pdf';
import Result_September from '../../assets/September.pdf';
import Sch_September from '../../assets/SepSc.pdf';
import Aug_Result from '../../assets/Aug_Re.pdf';
import Sch_August from '../../assets/August_Sch.pdf';
import July_result from '../../assets/JULY_Result.pdf';
import JulySch from '../../assets/JulySch.pdf';
import June_result from '../../assets/JUNE_RESULT.pdf';
import JuneSch from '../../assets/JuneSch.pdf';
import May_result from '../../assets/Result_May.pdf';
import April_result from '../../assets/Result_April.pdf';
import AprilSch from '../../assets/AprilSch.pdf';
import March_result from '../../assets/March_result.pdf';
import Febrary_result from '../../assets/HPTI Result Feb 2025.pdf';
import Schedule_February from '../../assets/SchFeb.pdf';
import January_result from '../../assets/JanuaryResult.pdf';
import JanSch from '../../assets/JanSch.pdf';
import december_result from '../../assets/DecemberResult.pdf';
import november from '../../assets/November.pdf';
import novemberResult from '../../assets/NovemberResult.pdf';
import Schedule_December from '../../assets/Schedule_December.pdf';
import october_result from '../../assets/OctoberResult.pdf';
import october from '../../assets/October.pdf';
import filePath1 from '../../assets/file.pdf';
import result from '../../assets/Result.pdf';

const legacyExamResults = [
  { heading: 'Exam Schedule for July 2026 Event', file: SchJuly },
  { heading: 'Computer Knowledge & Typing Test Result for June 2026', file: ResJune },
  { heading: 'Exam Schedule for June 2026 Event', file: Sch_June2026 },
  { heading: 'Computer Knowledge & Typing Test Result for May 2026', file: May2026Res },
  { heading: 'Exam Schedule for May 2026 Event', file: SchMay },
  { heading: 'Computer Knowledge & Typing Test Result for April 2026', file: ResApril },
  { heading: 'Exam Schedule for April 2026 Event', file: SchApril },
  { heading: 'Computer Knowledge & Typing Test Result for March 2026', file: March2026 },
  { heading: 'Exam Schedule for March 2026 Event', file: Mar2026Sch },
  { heading: 'Computer Knowledge & Typing Test Result for February 2026', file: Result_feb2026 },
  { heading: 'Computer Knowledge & Typing Test Result for JANUARY 2026', file: Result_Feb },
  { heading: 'Exam Schedule for January 2026 Event', file: Jan2026Sch },
  { heading: 'Computer Knowledge & Typing Test Result for December 2025', file: Dec2025Res },
  { heading: 'Exam Schedule for December 2025 Event', file: Dec_Sch },
  { heading: 'Computer Knowledge & Typing Test Result for November 2025', file: Nov_Res },
  { heading: 'Exam Schedule for November 2025 Event', file: Nov_Sch },
  { heading: 'Computer Knowledge & Typing Test Result for October 2025', file: OctResult25 },
  { heading: 'Exam Schedule for October 2025 Event', file: October_Sch },
  { heading: 'Computer Knowledge & Typing Test Result for September 2025', file: Result_September },
  { heading: 'Exam Schedule for September 2025 Event', file: Sch_September },
  { heading: 'Computer Knowledge & Typing Test Result for August 2025', file: Aug_Result },
  { heading: 'Exam Schedule for August 2025 Event', file: Sch_August },
  { heading: 'Computer Knowledge & Typing Test Result for July 2025', file: July_result },
  { heading: 'Exam Schedule for July 2025 Event', file: JulySch },
  { heading: 'Computer Knowledge & Typing Test Result for June 2025', file: June_result },
  { heading: 'Exam Schedule for June 2025 Event', file: JuneSch },
  { heading: 'Computer Knowledge & Typing Test Result for May 2025', file: May_result },
  { heading: 'Computer Knowledge & Typing Test Result for April 2025', file: April_result },
  { heading: 'Exam Schedule for April 2025 Event', file: AprilSch },
  { heading: 'Computer Knowledge & Typing Test Result for March 2025', file: March_result },
  { heading: 'Computer Knowledge & Typing Test Result for February 2025', file: Febrary_result },
  { heading: 'Exam Schedule for FEBRUARY 2025 Event', file: Schedule_February },
  { heading: 'Computer Knowledge & Typing Test Result January 2025', file: January_result },
  { heading: 'Exam Schedule for JANUARY 2025 Event', file: JanSch },
  { heading: 'Computer Knowledge & Typing Test Result December 2024', file: december_result },
  { heading: 'Exam Schedule for November 2024 Event', file: november },
  { heading: 'Computer Knowledge & Typing Test Result November 2024', file: novemberResult },
  { heading: 'Exam Schedule for December 2024 Event', file: Schedule_December },
  { heading: 'Computer Knowledge & Typing Test Result October 2024', file: october_result },
  { heading: 'Exam Schedule for October 2024 Event', file: october },
  { heading: 'Exam Schedule for Sept 2024 Event', file: filePath1 },
  { heading: 'Computer Knowledge & Typing Test Result September 2024', file: result },
];

export default legacyExamResults;
